
export default {
  name: 'CarouselItemStatic',
  props: {
    setHeight: {
      type: String,
      default: '',
    },
    setWidth: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 描述文字
    desc: {
      type: String,
      default: '',
    },
    // 图片地址
    svg: {
      type: String,
      default: 'Object',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
